import http from "../jslibs/axios/http";

// 分类列表
export const getCate = (data) => http.get("/v1/cms/GoodCate", data);
// �新增分类
export const addCate = (data) => http.post("/v1/cms/GoodCate", data);
// bianji分类
export const editCate = (data, uuid) => http.put(`/v1/cms/GoodCate/${uuid}`, data);
// 删除分类
export const deleteCate = (uuid) => http.delete(`/v1/cms/GoodCate/${uuid}`);
// 删除分类
export const setCateStatus = (uuid) => http.get(`/v1/cms/GoodCateStatus/${uuid}`);

// 商品列表
export const getGood = (data) => http.get("/v1/cms/good", data);
// �新增商品
export const addGood = (data) => http.post("/v1/cms/good", data);
// bianji商品
export const editGood = (data, uuid) => http.put(`/v1/cms/good/${uuid}`, data);
// 删除商品
export const deleteGood = (uuid) => http.delete(`/v1/cms/good/${uuid}`);
// 详情商品
export const GoodDetail = (uuid) => http.get(`/v1/cms/good/${uuid}`);
// 上下架商品
export const GoodStatus = (uuid) => http.get(`/v1/cms/GoodStatus/${uuid}`);

// 手机号列表
export const getSystemConfig = (data) => http.get("/v1/cms/SystemConfig", data);
// 新增手机号
export const addSystemConfig = (data) => http.post("/v1/cms/SystemConfig", data);
// 编辑手机号
export const editSystemConfig = (data, uuid) => http.put(`/v1/cms/SystemConfig/${uuid}`, data);
